//libs
import classNames from 'classnames';

//types
import { IAlphabetFilterProps } from '../types/IAlphabetFilterProps';

export default function AlphabetFilter({
    list,
    selectedLetter,
    selectLetter
}: IAlphabetFilterProps) {
    return (
        <div className="cities-filter-block__alphabet cities-filter-block-alphabet">
            {list.map(letter => {
                const classes = classNames(
                    'cities-filter-block-alphabet__item', 
                    {
                        'cities-filter-block-alphabet__item--active': selectedLetter === letter,
                    }
                );

                return (
                    <button
                        onClick={() => selectLetter(letter)}
                        className={classes}>{letter}
                    </button>
                )
            })}
        </div>
    );
}